import { useEffect, useState, useCallback, useRef } from 'react';
import { CustodianSearchParams } from '../../Models/custodian/custodianSearchParams';
import { rowsPerPage } from '../../settings/appConfig';
import useHttp from '../http/useHttp';

export default function useFetchAssociationsSearchResult() {
  const { postDataResponse, postData } = useHttp();
  const [isLoading, setIsLoading] = useState(true);
  const totalCountRef = useRef(0);
  useEffect(() => {
    totalCountRef.current = postDataResponse?.data?.count ?? 0;
  }, [postDataResponse]);

  const [searchParams, setSearchParams] = useState<CustodianSearchParams>({
    pageSize: rowsPerPage,
    pageNo: 0
  });

  const init = async () => {
    try {
      setIsLoading(true);
      totalCountRef.current = 0;
      await postData('EntityRelationship/search', {
        pageNo: 0
      } as CustodianSearchParams);
      setIsLoading(false);
    } catch (error) {
      console.log(`Exception while doing search entity relationship: ${error}`);
      setIsLoading(false);
    }

  };
  useEffect(() => {
    init();
  }, []);

  const pageChanged = useCallback(
    async (pageNumber: number) => {
      try {
        setIsLoading(true);
        let newSearch: CustodianSearchParams = {
          searchText: searchParams.searchText,
          type: searchParams.type,
          pageSize: rowsPerPage,
          pageNo: pageNumber
        };
        await postData('EntityRelationship/search', newSearch);
        setSearchParams({ ...newSearch });
        setIsLoading(false);
      } catch (error) {
        console.log(`Exception while doing search entity relationship: ${error}`);
        setIsLoading(false);
      }
    },
    [searchParams],
  );

  const searchChanged = useCallback(async (searchText?: string, stateId?: string) => {
    try {
      setIsLoading(true);
      totalCountRef.current = 0;
      let newSearch: CustodianSearchParams = {
        searchText,
        type: stateId,
        pageSize: rowsPerPage,
        pageNo: 0
      };
      await postData('EntityRelationship/search', newSearch);
      setSearchParams({ ...newSearch });
      setIsLoading(false);
    } catch (error) {
      console.log(`Exception while doing search entity relationship: ${error}`);
      setIsLoading(false);
    }

  }, []);

  return {
    data: postDataResponse?.data ?? { count: totalCountRef.current, custodians: [] },
    pageChanged,
    searchChanged,
    isLoading
  };
}
